module.exports = __webpack_public_path__ + "img/3f201f98f14c45eb5dd517f2f718c9d6.1deb0143.png";